import React from 'react';

const Trending_Searches = () => {
  return (
    <>
      {/* <section>
        <div className="container-fluid-lg">
        <div className="title" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
          <h2>Trending Searches</h2>
          <span className="title-leaf">
            <svg className="icon-width">
              <use href="../assets/svg/leaf.svg#leaf"></use>
            </svg>
          </span>
       
        </div>
        <div
          className="category-slider-2 product-wrapper no-arrow"
          style={{ display: 'flex', flexDirection: 'column' }}
        >
          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/magnesium (1).png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Magnesium</h5>
              </div>
            </a>
          </div>

          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/molecule (1).png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Collagen</h5>
              </div>
            </a>
          </div>

          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/health.png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Protein</h5>
              </div>
            </a>
          </div>

          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/omega (1).png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Omega</h5>
              </div>
            </a>
          </div>

          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/protein.png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Sleep</h5>
              </div>
            </a>
          </div>

          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/multivitamin (1).png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Multivitamins</h5>
              </div>
            </a>
          </div>

          <div>
            <a
              href="/Shop"
              className="category-box category-dark"
            >
              <div>
                <img
                  src="/assets/images/immune-booster (2).png"
                  className="blur-up lazyload"
                  alt="img"
                />
                <h5>Immunity Boosters</h5>
              </div>
            </a>
          </div>
        </div>
        </div>
      </section> */}

 <section className="w-full py-4">
          <div className="title" style={{ 
  textAlign: 'center', 
  display: 'flex', 
  flexDirection: 'column', 
  alignItems: 'center',
  width: '100%' 
}}>
          <h2>Trending Searches</h2>
          <span className="title-leaf">
            <svg className="icon-width">
              <use href="../assets/svg/leaf.svg#leaf"></use>
            </svg>
          </span>
       
        </div>
      <div className="container-fluid-lg">
        <div className="mx-auto w-full max-w-[1200px]">
          <a href="/Shop" className="block w-full">
            <img
              src="/assets/images/Trending_Search.png"
              alt="Trending Searches"
              className="block w-full object-contain"
              style={{
                width: "100%",
                height: "auto",
                maxHeight: "none",
                objectFit: "contain",
              }}
            />
          </a>
        </div>
      </div>
    </section>
    </>
  );
};

export default Trending_Searches;
